import { Tabs, TabsProps } from "antd";
import styles from "./index.module.css";

export const TabsComponent = (tabsProps: TabsProps) => {
  return <Tabs {...tabsProps} className={styles.tabs + " " + tabsProps.className} />;
};
